var React = require('react');

function Messenger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M256 245.4c-5.82 0-10.54 4.4-10.54 9.81a9.56 9.56 0 0 0 3.93 7.65v3.74l3.59-1.98c.95.27 1.97.41 3.02.41 5.82 0 10.54-4.4 10.54-9.81 0-5.43-4.72-9.82-10.54-9.82zm1.05 13.22l-2.69-2.88-5.23 2.88 5.76-6.15 2.75 2.88 5.17-2.88-5.76 6.15z"}));
}

Messenger.displayName = "Messenger";

Messenger.defaultProps = {"viewBox":"244 244 24 24"};

module.exports = Messenger;

Messenger.default = Messenger;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Messenger.svg
// module id = 646
// module chunks = 168707334958949